import { render, staticRenderFns } from "./Customer-Service-Form.vue?vue&type=template&id=4ae51b90"
import script from "./Customer-Service-Form.vue?vue&type=script&lang=js"
export * from "./Customer-Service-Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports